import { HTMLSelect } from "@blueprintjs/core";
import { InputGroup } from "@focus/focusUI";
import type { CardSortBy, SortDirection } from "../../types/releaseNotes";

type Props = {
  searchTerm: string;
  sortBy: CardSortBy;
  sortDirection: SortDirection;
  total: number;
  filtered: number;
  onSearchChange: (value: string) => void;
  onSortChange: (value: CardSortBy) => void;
  onDirectionChange: (value: SortDirection) => void;
};

const sortOptions: Array<{ label: string; value: CardSortBy }> = [
  { label: "Version", value: "version" },
  { label: "Title", value: "title" },
  { label: "Release Date", value: "releaseDate" },
];

const sortDirectionOptions: Array<{ label: string; value: SortDirection }> = [
  { label: "Ascending", value: "asc" },
  { label: "Descending", value: "desc" },
];

export const ReleaseNotesToolbar = ({
  searchTerm,
  sortBy,
  sortDirection,
  total,
  filtered,
  onSearchChange,
  onDirectionChange,
  onSortChange,
}: Props) => {
  return (
    <div className="shrink-0 border-b border-slate-200 bg-white px-4 py-3">
      <div className="focusoc-form-shell flex flex-wrap items-end gap-3">
        <label className="flex min-w-[220px] flex-1 flex-col gap-1.5">
          <span className="text-xs font-semibold uppercase text-slate-500">
            Search
          </span>
          <InputGroup
            leftIcon="search"
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Version, title, release date..."
            value={searchTerm}
          />
        </label>

        <label className="flex min-w-[180px] flex-col gap-1.5">
          <span className="text-xs font-semibold uppercase text-slate-500">
            Sort by
          </span>
          <HTMLSelect
            fill
            onChange={(event) => onSortChange(event.target.value as CardSortBy)}
            options={sortOptions}
            value={sortBy}
          />
        </label>

        <label className="flex min-w-[150px] flex-col gap-1.5">
          <span className="text-xs font-semibold uppercase text-slate-500">
            Order
          </span>
          <HTMLSelect
            fill
            onChange={(event) =>
              onDirectionChange(event.target.value as SortDirection)
            }
            options={sortDirectionOptions}
            value={sortDirection}
          />
        </label>

        <span className="mb-1 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold uppercase text-slate-600 ring-1 ring-inset ring-slate-200">
          {filtered} / {total}
        </span>
      </div>
    </div>
  );
};
